const updateMobileSyncCount = ({ syncDone, retryAssetCount = {} }) => {
  return {
    completedInspectionCount: {
      op: 'Replace',
      value: syncDone?.inspection || 0
    },
    completedInspectionPhotoCount: {
      op: 'Replace',
      value: syncDone?.inspectionPhotoCount || 0
    },
    completedInspectionDocumentCount: {
      op: 'Replace',
      value: syncDone?.inspectionDocumentCount || 0
    },

    completedWorkOrderCount: {
      op: 'Replace',
      value: syncDone?.workOrder || 0
    },
    completedWorkOrderPhotoCount: {
      op: 'Replace',
      value: syncDone?.workOrderPhotoCount || 0
    },
    completedWorkOrderDocumentCount: {
      op: 'Replace',
      value: syncDone?.workOrderDocumentCount || 0
    },

    completedWorkRequestCount: {
      op: 'Replace',
      value: syncDone?.workRequest || 0
    },
    completedWorkRequestPhotoCount: {
      op: 'Replace',
      value: syncDone?.workRequestPhotoCount || 0
    },
    completedWorkRequestDocumentCount: {
      op: 'Replace',
      value: syncDone?.workRequestDocumentCount || 0
    },

    completedIncidentCount: {
      op: 'Replace',
      value: syncDone?.hseEvents || 0
    },
    completedIncidentPhotoCount: {
      op: 'Replace',
      value: syncDone?.incidentPhotoCount || 0
    },
    completedIncidentDocumentCount: {
      op: 'Replace',
      value: syncDone?.incidentDocumentCount || 0
    },

    completedCheckCount: {
      op: 'Replace',
      value: syncDone?.checks || 0
    },
    completedCheckPhotoCount: {
      op: 'Replace',
      value: syncDone?.checkPhotoCount || 0
    },
    completedCheckDocumentCount: {
      op: 'Replace',
      value: syncDone?.checkDocumentCount || 0
    },

    completedEditedAssetsCount: {
      op: 'Replace',
      value: syncDone?.editedEquipmentAssets || 0
    },

    completedNewAssetsCount: {
      op: 'Replace',
      value: syncDone?.newEquipmentAssets || 0
    },

    completedRetryInspectionCount: {
      op: 'Replace',
      value: retryAssetCount?.retryInspectionsCount || 0
    },
    completedRetryWorkOrderCount: {
      op: 'Replace',
      value: retryAssetCount?.retryWorkOrdersCount || 0
    },
    completedRetryWorkRequestCount: {
      op: 'Replace',
      value: retryAssetCount?.retryWorkRequestsCount || 0
    },
    completedRetryIncidentCount: {
      op: 'Replace',
      value: retryAssetCount?.retryIncidentCOunt || 0
    },
    completedRetryCheckCount: {
      op: 'Replace',
      value: retryAssetCount?.retryCheckCount || 0
    },
    completedRetryDocumentCount: {
      op: 'Replace',
      value: retryAssetCount?.retryDocumentCount || 0
    },
    completedRetryPhotoCount: {
      op: 'Replace',
      value: retryAssetCount?.retryPhotoCount || 0
    },

    completedRetryNewAssetsCount: {
      op: 'Replace',
      value: retryAssetCount?.retryNewEquipmentAssetsCount || 0
    },

    completedRetryEditedAssetsCount: {
      op: 'Replace',
      value: retryAssetCount?.retryEditedEquipmentAssetsCount || 0
    }
  };
};

const addMobileSyncCount = ({ pendingOrderPhotosDocumentsLength }) => {
  return {
    inspectionCount: pendingOrderPhotosDocumentsLength?.inspection || 0,
    inspectionPhotoCount: pendingOrderPhotosDocumentsLength?.inspectionPhotoCount || 0,
    inspectionDocumentCount: pendingOrderPhotosDocumentsLength?.inspectionDocumentCount || 0,
    workOrderCount: pendingOrderPhotosDocumentsLength?.workOrder || 0,
    workOrderPhotoCount: pendingOrderPhotosDocumentsLength?.workOrderPhotoCount || 0,
    workOrderDocumentCount: pendingOrderPhotosDocumentsLength?.workOrderDocumentCount || 0,
    workRequestCount: pendingOrderPhotosDocumentsLength?.workRequest || 0,
    workRequestPhotoCount: pendingOrderPhotosDocumentsLength?.workRequestPhotoCount || 0,
    workRequestDocumentCount: pendingOrderPhotosDocumentsLength?.workRequestDocumentCount || 0,
    incidentCount: pendingOrderPhotosDocumentsLength?.hseEvents || 0,
    incidentPhotoCount: pendingOrderPhotosDocumentsLength?.incidentPhotoCount || 0,
    incidentDocumentCount: pendingOrderPhotosDocumentsLength?.incidentDocumentCount || 0,

    checkCount: pendingOrderPhotosDocumentsLength?.checks || 0,
    checkPhotoCount: pendingOrderPhotosDocumentsLength?.checksPhotoCount || 0,
    checkDocumentCount: pendingOrderPhotosDocumentsLength?.checksDocumentCount || 0,

    editedAssetsCount: pendingOrderPhotosDocumentsLength?.editedEquipmentAssets || 0,
    newAssetsCount: pendingOrderPhotosDocumentsLength?.newEquipmentAssets || 0,

    inspectionIds: pendingOrderPhotosDocumentsLength?.inspectionIds || [],
    workOrderIds: pendingOrderPhotosDocumentsLength?.workOrderIds || [],
    workRequestIds: pendingOrderPhotosDocumentsLength?.workRequestIds || [],
    assetChecksIds: pendingOrderPhotosDocumentsLength?.assetChecksIds || [],
    incidentIds: pendingOrderPhotosDocumentsLength?.incidentIds || [],
    photoIds: pendingOrderPhotosDocumentsLength?.photoIds || [],
    documentIds: pendingOrderPhotosDocumentsLength?.documentIds || [],
    editAssetIds: pendingOrderPhotosDocumentsLength?.editedEquipmentAssetsIds || [],
    newAssetIds: pendingOrderPhotosDocumentsLength?.newEquipmentAssetsIds || [],

    retryInspectionCount: pendingOrderPhotosDocumentsLength?.retryInspectionCount || 0,
    retryWorkOrderCount: pendingOrderPhotosDocumentsLength?.retryWorkOrderCount || 0,
    retryWorkRequestCount: pendingOrderPhotosDocumentsLength?.retryWorkRequestCount || 0,
    retryIncidentCount: pendingOrderPhotosDocumentsLength?.retryIncidentCount || 0,
    retryCheckCount: pendingOrderPhotosDocumentsLength?.retryCheckCount || 0,
    retryDocumentCount: pendingOrderPhotosDocumentsLength?.retryDocumentCount || 0,
    retryPhotoCount: pendingOrderPhotosDocumentsLength?.retryPhotoCount || 0,

    retryEditedAssetsCount: pendingOrderPhotosDocumentsLength?.retryEditedEquipmentAssetsCount || 0,
    retryNewAssetsCount: pendingOrderPhotosDocumentsLength?.retryNewEquipmentAssetsCount || 0
  };
};

export { updateMobileSyncCount, addMobileSyncCount };
